import request from 'superagent';
import { STRINGS, createDynamicStrings } from 'config';
import media from 'styles/media';

const createRequest = (requestMethod, url) => {
  return requestMethod(url)
    .timeout({
      response: STRINGS.API_REQUEST_TIMEOUT.RESPONSE,
      deadline: STRINGS.API_REQUEST_TIMEOUT.DEADLINE,
    });
};

const createRootRequest = requestMethod => (route, practiceId) => {
  const DYNAMIC_ENV_STRINGS = createDynamicStrings();
  const ROOT_URL = media.isInternetExplorer
    ? DYNAMIC_ENV_STRINGS.API.IE_ROOT_URL
    : DYNAMIC_ENV_STRINGS.API.ROOT_URL;
  return createRequest(requestMethod, `${ROOT_URL(practiceId)}${route}`);
};

const createConsultationRootRequest = requestMethod => (route, practiceId) => {
  return createRootRequest(requestMethod)(`${STRINGS.API.ROOT_PATH}${route}`, practiceId);
};

export const apiPost = createConsultationRootRequest(request.post);

export const apiGet = createConsultationRootRequest(request.get);

export const apiDelete = createConsultationRootRequest(request.delete);

export const apiExternalGet = createRootRequest(request.get);

export const apiPostSubmit = practiceId => {
  const DYNAMIC_ENV_STRINGS = createDynamicStrings();
  return createRequest(request.post, DYNAMIC_ENV_STRINGS.API.SUBMISSION_URL(practiceId));
};

export const apiGetPostcode = (practiceId, postcode) => {
  const DYNAMIC_ENV_STRINGS = createDynamicStrings();
  return request.get(DYNAMIC_ENV_STRINGS.API.POSTCODE_URL(practiceId, postcode));
};

export const apiGetAddresses = (practiceId, postcode) => {
  const DYNAMIC_ENV_STRINGS = createDynamicStrings();
  return request.get(DYNAMIC_ENV_STRINGS.API.ADDRESSES_URL(practiceId, postcode));
};
